import { ApplicaDataProvider } from './provider';
import { ApplicaDataProviderConfig } from './types';

/**
 * @deprecated Istanciate a new ApplicaDataProvider instead of using this function (new ApplicaDataProvider).
 */
function createDataProvider(config: ApplicaDataProviderConfig): ApplicaDataProvider {
  return new ApplicaDataProvider(config);
}

export * from './provider';
export * from './utils';
export { createDataProvider };
